/* eslint-disable array-bracket-newline */
import { Network } from '@kattana-io/common';
import { useState } from 'react';
import Text from '../../../atoms/Text';
import useTicker from '../../../hooks/useTicker';
import { ICurrentState } from '../../../reducers/current';
import Loader from '../../common/Loader';
import useTickerLivePrice from '../../Watchlist/useTickerLivePrice';
import CoinNews from '../CoinNews';
import usePriceChange from '../usePriceChange';
import DexCoinInfo from './DexCoinInfo';
import DexCoinLiquidity from './DexCoinLiquidity';
import useDexPoolInfo from './useDexPoolInfo';

interface IDexCoinProps {
  current: ICurrentState;
}

const modes = ['About', 'Liquidity', 'News'];

const DexCoin = ({ current }: IDexCoinProps) => {
  const network = Network.fromChain(current.chain);
  const { loading, data, poolData } = useDexPoolInfo(current);
  const { price } = useTickerLivePrice(current);
  const { priceChange, priceChangePercent } = usePriceChange(
    Number(price.slice(1)),
    current.flipped,
    current.chain,
    current.address
  );

  const [mode, setMode] = useState<string>('About');
  const { base, quote } = useTicker(current);

  if (loading) {
    return (
      <div className='info_widget'>
        <div className='info_widget__loader'>
          <Loader />
        </div>
      </div>
    );
  }

  if (!data || !poolData) {
    return (
      <div className='info_widget'>
        <Text size={14} className='notice text--grey-600'>
          Could not fetch data
        </Text>
      </div>
    );
  }

  const mergedData = {
    ...current,
    info: poolData,
    ...data,
  };

  return (
    <div className='container'>
      <div className='mode_row'>
        {modes.map((item) => (
          <div
            key={item}
            className={
              mode === item ? 'mode_row__item--active' : 'mode_row__item'
            }
            onClick={() => setMode(item)}
          >
            <Text size={12}>{item}</Text>
          </div>
        ))}
      </div>
      {mode === 'About' && (
        <DexCoinInfo
          {...mergedData}
          price={price}
          priceChange={priceChange}
          priceChangePercent={priceChangePercent}
          network={network}
        />
      )}
      {mode === 'Liquidity' && (
        <DexCoinLiquidity {...mergedData} base={base} quote={quote} />
      )}
      {mode === 'News' && <CoinNews slug={base} />}
    </div>
  );
};

export default DexCoin;
